import React from "react";
import { skills } from "../data";
import { BiBadgeCheck, BiChip } from "react-icons/bi";
import useRevealOnScroll from "../hooks/useRevealOnScroll";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function Skills() {
  const { elementRef, isVisible } = useRevealOnScroll();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section
      id="skills"
      ref={elementRef}
      className={`body-font ${isVisible ? "animate-fade-in-up" : ""}`}
    >
      <div className="container mx-auto px-5 py-16">
        <div className="mb-16 text-center text-white">
          <BiChip className="mb-4 inline-block text-4xl text-coding-color" />
          <h1 className="skills-header mb-4 text-3xl font-medium title-font text-white sm:text-4xl">
            {t.skills.title}
          </h1>
          <p className="mx-auto text-lg leading-relaxed md:text-xl lg:w-3/4 xl:w-2/4">
            {t.skills.body}
          </p>
        </div>
        <div className="-mx-2 flex flex-wrap sm:mx-auto sm:mb-2 lg:w-4/5">
          {skills.map((skill, index) => (
            <div
              key={skill}
              className="w-full p-2 sm:w-1/2"
            >
              <div
                className={`flex h-full items-center rounded bg-gray-800 p-4 transition duration-500 ${
                  isVisible ? "animate-fade-in-up" : ""
                } hover:-translate-y-1`}
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <BiBadgeCheck className="mr-4 h-6 w-6 flex-shrink-0 text-green-400" />
                <span className="title-font font-medium text-white">
                  {skill}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
